/* VES · menú de mapas. Dos responsabilidades:

   1) Cerrar los <details.ves-map> (clic afuera / Esc) — el selector que ya
      renderizan el footer y las barras de confianza vía ves-map-links.liquid.

   2) Elevar CUALQUIER enlace de mapas del tema a ese mismo selector. La
      dirección es pinchable en cuatro sitios más (anuncio superior, ítem
      "Cómo llegar" del menú Contacto, tips del equipo y respuestas del FAQ),
      y ahí no se puede renderizar el snippet: los tres primeros son settings
      de tipo url y el último es HTML libre. Interceptar el clic es lo único
      que cubre los cuatro sin tocar cada sección ni alterar su maquetación.
      El menú flotante reutiliza las clases .ves-map__menu / .ves-map__opt,
      que son globales porque el footer se pinta en todas las páginas.
*/
(function () {
  if (window.__vesMapInit) return;
  window.__vesMapInit = true;

  /* Coordenadas de la clínica: respaldo cuando el enlace no las trae. */
  var LAT = '-33.418819';
  var LNG = '-70.598627';
  var LABEL = 'Clínica Vie et Santé';

  /* Solo enlaces de NAVEGACIÓN, en la forma canónica que usa el tema. Se deja
     fuera a propósito /maps/place/…!1b1, que es el deep-link a las reseñas de
     Google del negocio: ahí el visitante quiere leer reseñas, no que le
     preguntemos con qué app llegar. */
  var SEL = [
    'a[href*="maps/search/?api=1"]',
    'a[href*="maps.app.goo.gl"]',
    'a[href*="maps.apple.com"]',
    'a[href*="waze.com"]'
  ].join(',');

  var floater = null;

  function closeAll(except) {
    document.querySelectorAll('details.ves-map[open]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }

  function closeFloater() {
    if (floater) {
      floater.remove();
      floater = null;
    }
  }

  /* Saca lat,lng del propio enlace para no perder el pin si algún día apunta
     a otro lugar. Cubre ?query= / ?ll= / ?daddr= y el /@lat,lng de Google. */
  function coordsFrom(href) {
    var m =
      href.match(/[?&](?:query|ll|daddr)=(-?\d{1,3}\.\d+)(?:,|%2C)(-?\d{1,3}\.\d+)/i) ||
      href.match(/\/@(-?\d{1,3}\.\d+),(-?\d{1,3}\.\d+)/);
    return m ? [m[1], m[2]] : [LAT, LNG];
  }

  function options(lat, lng) {
    var q = encodeURIComponent(LABEL);
    return [
      ['Google Maps', 'https://www.google.com/maps/search/?api=1&query=' + lat + ',' + lng],
      ['Apple Maps', 'https://maps.apple.com/?ll=' + lat + ',' + lng + '&q=' + q],
      ['Waze', 'https://waze.com/ul?ll=' + lat + ',' + lng + '&navigate=yes']
    ];
  }

  function openFloater(anchor) {
    closeAll(null);
    closeFloater();

    var c = coordsFrom(anchor.getAttribute('href') || '');
    var box = document.createElement('div');
    box.className = 'ves-map__menu';
    box.setAttribute('role', 'menu');
    box.style.position = 'fixed';
    box.style.zIndex = '60';

    options(c[0], c[1]).forEach(function (o) {
      var a = document.createElement('a');
      a.className = 'ves-map__opt';
      a.setAttribute('role', 'menuitem');
      a.href = o[1];
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = o[0];
      box.appendChild(a);
    });

    document.body.appendChild(box);

    /* Posicionado tras insertarlo, que es cuando ya tiene medidas. */
    var r = anchor.getBoundingClientRect();
    var w = box.offsetWidth;
    var h = box.offsetHeight;
    var left = Math.max(12, Math.min(r.left, window.innerWidth - w - 12));
    var top = r.bottom + 8;
    if (top + h > window.innerHeight - 12) {
      top = Math.max(12, r.top - h - 8);
    }
    box.style.left = left + 'px';
    box.style.top = top + 'px';

    floater = box;
    box.querySelector('a').focus();
  }

  function upgrade(root) {
    (root || document).querySelectorAll(SEL).forEach(function (a) {
      if (a.dataset.vesMap) return;
      if (a.closest('.ves-map__menu')) return; /* las opciones del propio menú */
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/maps/place/') !== -1) return; /* reseñas, no ubicación */
      a.dataset.vesMap = '1';
      a.setAttribute('aria-haspopup', 'true');
      a.addEventListener('click', function (e) {
        /* Respeta abrir en pestaña nueva o con botón central. */
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
        e.preventDefault();
        if (floater) {
          closeFloater();
          return;
        }
        openFloater(a);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var open = document.querySelector('details.ves-map[open]');
    if (open && !open.contains(e.target)) closeAll(null);
    if (
      floater &&
      !floater.contains(e.target) &&
      !(e.target.closest && e.target.closest('[data-ves-map]'))
    ) {
      closeFloater();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAll(null);
      closeFloater();
    }
  });

  /* Al abrir uno, cierra los demás. */
  document.addEventListener(
    'toggle',
    function (e) {
      var d = e.target;
      if (d.matches && d.matches('details.ves-map') && d.open) {
        closeAll(d);
        closeFloater();
      }
    },
    true
  );

  /* El flotante está anclado a una posición fija: si la página se mueve, se cierra. */
  window.addEventListener('scroll', closeFloater, true);
  window.addEventListener('resize', closeFloater);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      upgrade();
    });
  } else {
    upgrade();
  }

  /* Secciones recargadas desde el editor de temas. */
  document.addEventListener('shopify:section:load', function (e) {
    upgrade(e.target);
  });
})();
